import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import Blog_1 from '../../../assets/images/home_page_4/blog/01.png'
import Blog_2 from '../../../assets/images/home_page_4/blog/02.png'
import Blog_3 from '../../../assets/images/home_page_4/blog/03.png'
import Blog_4 from '../../../assets/images/home_page_4/blog/04.png'
import Blog_5 from '../../../assets/images/home_page_4/blog/05.png'
import Blog_6 from '../../../assets/images/home_page_4/blog/06.png'
import Blog_7 from '../../../assets/images/home_page_4/blog/07.png'
import Blog_8 from '../../../assets/images/home_page_4/blog/08.png'

// Custom Previous Arrow
const PrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <button type="button" className={`${className} slick-prev`} onClick={onClick}>
            <i className="flaticon-left-arrow-1" />
        </button>
    );
};

// Custom Next Arrow
const NextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <button type="button" className={`${className} slick-next`} onClick={onClick}>
            <i className="flaticon-right-arrow-1" />
        </button>
    );
};

const Sliders = {
    slidesToShow: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 1000,
    slidesToScroll: 1,
    dots: true,
    nav: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,


}


const Blog = () => {
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);

    const handlePlayClick = () => {
        setIsVideoPlaying(true);
    };
    return (
        <>
            <section id="blog" className="blog-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-7">
                            <div className="blog-block">

                                <Slider className="slider blog-slider-img blog-img" {...Sliders} arrows='true'>
                                    <Link to="/BlogDetails" title="">
                                        <img
                                            src={Blog_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                    <Link to="/BlogDetails" title="">
                                        <img
                                            src={Blog_2}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                    <Link to="/BlogDetails" title="">
                                        <img
                                            src={Blog_3}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                    <Link to="/BlogDetails" title="">
                                        <img
                                            src={Blog_4}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                </Slider>
                                <div className="blog-dtls">
                                    <ul className="blog-tags">
                                        <li>
                                            <Link to="/BlogDetails" title="">
                                                <i className="flaticon-offer" /> Web design
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/BlogDetails" title="">
                                                <i className="flaticon-comment-1" /> Comments (05)
                                            </Link>
                                        </li>
                                    </ul>
                                    <h2 className="blog-heading">
                                        <Link to="/BlogDetails" title="">
                                            Connecting the world through seamless transportation
                                        </Link>
                                    </h2>
                                    <p>
                                        Aliquam eros justo, posuere loborti viverra lao ullamcorper
                                        posuere viverra .Aliquam eros justo, posuere Aliquam eros justo,
                                        posuere loborti viverra laoreet matti ullamcorper
                                    </p>
                                    <Link to="/BlogDetails" className="btn btn-primary" title="">
                                        Read more <i className="flaticon-right-arrows" />
                                    </Link>
                                </div>
                            </div>
                            <div className="blog-block">
                                <div className="blog-img">
                                    <div className="video-item hidden-xs">
                                        <div className="video-device">
                                            {!isVideoPlaying ? (
                                                <>
                                                    <Link to="/Blogdetails" title="">
                                                        <img
                                                            src={Blog_2}
                                                            className="img-fluid"
                                                            alt=""
                                                            layout="intrinsic"
                                                        />
                                                    </Link>
                                                    <div className="video-preview">
                                                        <button className="btn-video-play" onClick={handlePlayClick}>
                                                            <i className="flaticon-play-button" />
                                                        </button>
                                                    </div>

                                                </>
                                            ) : (
                                                <div>
                                                    <div className="video-preview">
                                                        <iframe
                                                            src="https://www.youtube.com/embed/ZMdCsIaE7II?autoplay=1&showinfo=0"
                                                            frameBorder={0}
                                                            allowFullScreen
                                                        />
                                                    </div>
                                                    <div className="blog-dtls-video">
                                                        <ul className="blog-tags">
                                                            <li>
                                                                <Link to="/BlogDetails" title="">
                                                                    <i className="flaticon-offer" /> Web design
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link to="/BlogDetails" title="">
                                                                    <i className="flaticon-comment-1" /> Comments (05)
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                        <h2 className="blog-heading">
                                                            <Link to="/BlogDetails" title="">
                                                                Connecting the world through seamless transportation
                                                            </Link>
                                                        </h2>
                                                        <p>
                                                            Aliquam eros justo, posuere loborti viverra lao ullamcorper
                                                            posuere viverra .Aliquam eros justo, posuere Aliquam eros justo,
                                                            posuere loborti viverra laoreet matti ullamcorper
                                                        </p>
                                                        <Link to="/BlogDetails" className="btn btn-primary" title="">
                                                            Read more <i className="flaticon-right-arrows" />
                                                        </Link>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="blog-dtls-video">
                                    <ul className="blog-tags">
                                        <li>
                                            <Link to="/BlogDetails" title="">
                                                <i className="flaticon-offer" /> Web design
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/BlogDetails" title="">
                                                <i className="flaticon-comment-1" /> Comments (05)
                                            </Link>
                                        </li>
                                    </ul>
                                    <h2 className="blog-heading">
                                        <Link to="/BlogDetails" title="">
                                            Connecting the world through seamless transportation
                                        </Link>
                                    </h2>
                                    <p>
                                        Aliquam eros justo, posuere loborti viverra lao ullamcorper
                                        posuere viverra .Aliquam eros justo, posuere Aliquam eros justo,
                                        posuere loborti viverra laoreet matti ullamcorper
                                    </p>
                                    <Link to="/BlogDetails" className="btn btn-primary" title="">
                                        Read more <i className="flaticon-right-arrows" />
                                    </Link>
                                </div>
                            </div>
                            <div className="blog-block">
                                <div className="blog-img">
                                    <Link to="/BlogDetails" title="">
                                        <img
                                            src={Blog_3}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                </div>
                                <div className="blog-dtls">
                                    <ul className="blog-tags">
                                        <li>
                                            <Link to="/BlogDetails" title="">
                                                <i className="flaticon-offer" /> Web design
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/BlogDetails" title="">
                                                <i className="flaticon-comment-1" /> Comments (05)
                                            </Link>
                                        </li>
                                    </ul>
                                    <h2 className="blog-heading">
                                        <Link to="/BlogDetails" title="">
                                            Connecting the world through seamless transportation
                                        </Link>
                                    </h2>
                                    <p>
                                        Aliquam eros justo, posuere loborti viverra lao ullamcorper
                                        posuere viverra .Aliquam eros justo, posuere Aliquam eros justo,
                                        posuere loborti viverra laoreet matti ullamcorper
                                    </p>
                                    <Link to="/BlogDetails" className="btn btn-primary" title="">
                                        Read more <i className="flaticon-right-arrows" />
                                    </Link>
                                </div>
                            </div>
                            <div className="blog-block">
                                <div className="blog-img">
                                    <Link to="/BlogDetails" title="">
                                        <img
                                            src={Blog_4}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </Link>
                                </div>
                                <div className="blog-dtls">
                                    <ul className="blog-tags">
                                        <li>
                                            <Link to="/BlogDetails" title="">
                                                <i className="flaticon-offer" /> Web design
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/BlogDetails" title="">
                                                <i className="flaticon-comment-1" /> Comments (05)
                                            </Link>
                                        </li>
                                    </ul>
                                    <h2 className="blog-heading">
                                        <Link to="/BlogDetails" title="">
                                            Connecting the world through seamless transportation
                                        </Link>
                                    </h2>
                                    <p>
                                        Aliquam eros justo, posuere loborti viverra lao ullamcorper
                                        posuere viverra .Aliquam eros justo, posuere Aliquam eros justo,
                                        posuere loborti viverra laoreet matti ullamcorper
                                    </p>
                                    <Link to="/BlogDetails" className="btn btn-primary" title="">
                                        Read more <i className="flaticon-right-arrows" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5">
                            <div className="blog-category-block">
                                <h3 className="blog-category-heading">Category</h3>
                                <ul>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-folder" /> Ducimus Laborum Beatae
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-folder" /> In omnis quos
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-folder" /> Numquam ut enim
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-folder" /> Pariatur quia eaque
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-folder" /> Reprehenderit repellendus sunt
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="blog-category-block">
                                <h3 className="blog-category-heading">Recent Posts</h3>
                                <div className="blog-post-block">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="blog-post-img">
                                                <Link to="/BlogDetails" title="">
                                                    <img
                                                        src={Blog_5}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-8 col-8">
                                            <div className="blog-post-dtls">
                                                <h3 className="blog-post-title">
                                                    <Link to="/BlogDetails" title="">
                                                        Principle stability in the future with activity
                                                    </Link>
                                                </h3>
                                                <p>
                                                    <i className="flaticon-calendar" /> 20 Aug,2022
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="blog-post-block">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="blog-post-img">
                                                <Link to="/BlogDetails" title="">
                                                    <img
                                                        src={Blog_6}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-8 col-8">
                                            <div className="blog-post-dtls">
                                                <h3 className="blog-post-title">
                                                    <Link to="/BlogDetails" title="">
                                                        How to invent a law &amp; pass it in parliament
                                                    </Link>
                                                </h3>
                                                <p>
                                                    <i className="flaticon-calendar" /> 20 Aug,2022
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="blog-post-block">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="blog-post-img">
                                                <Link to="/BlogDetails" title="">
                                                    <img
                                                        src={Blog_7}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-8 col-8">
                                            <div className="blog-post-dtls">
                                                <h3 className="blog-post-title">
                                                    <Link to="/BlogDetails" title="">
                                                        Principle stability in the future with activity
                                                    </Link>
                                                </h3>
                                                <p>
                                                    <i className="flaticon-calendar" /> 20 Aug,2022
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="blog-post-block">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-4">
                                            <div className="blog-post-img">
                                                <Link to="/BlogDetails" title="">
                                                    <img
                                                        src={Blog_8}
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-8 col-8">
                                            <div className="blog-post-dtls">
                                                <h3 className="blog-post-title">
                                                    <Link to="/BlogDetails" title="">
                                                        How to invent a law &amp; pass it in parliament
                                                    </Link>
                                                </h3>
                                                <p>
                                                    <i className="flaticon-calendar" /> 20 Aug,2022
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="blog-category-block">
                                <h3 className="blog-category-heading">Popular Tags</h3>
                                <div className="blog-popular-block">
                                    <ul>
                                        <li>
                                            <Link to="#" title="">
                                                Facilities
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Children
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Policy
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Vote
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Medical
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Education
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="#" title="">
                                                Meeting
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Blog
